import React, { useState } from "react";
import axios from "axios";

const EditServer = () => {
  const [server, setServer] = useState({
    id: "",
    name: "",
    ip: "",
  });

  const handleChange = (e) => {
    setServer({ ...server, [e.target.name]: e.target.value });
  };

  const updateServer = async () => {
    try {
      await axios.post(
        "https://streamsrvbac.n-tools.info/keymanage/server/update",
        server
      );

      alert("Server updated successfully");
    } catch (err) {
      alert("Update failed");
    }
  };

  return (
    <div style={{ padding: 20, color: "white" }}>
      <h2>Edit Server</h2>

      <input name="id" placeholder="Server ID" onChange={handleChange} />
      <input name="name" placeholder="Server Name" onChange={handleChange} />
      <input name="ip" placeholder="Server IP" onChange={handleChange} />

      <button onClick={updateServer}>Update</button>
    </div>
  );
};

export default EditServer;
